import React from 'react';
import { Info } from 'lucide-react';

const TB_LABEL = {
  net_run_rate: () => 'Net Run Rate',
  h2h_wins: () => 'Head-to-head wins',
  h2h_point_diff: (l) => `Head-to-head ${l.pdFull.toLowerCase()}`,
  point_diff: (l) => l.pdFull,
  points_for: (l) => l.pfFull,
  points_against: (l) => `Fewest ${l.paFull.toLowerCase()}`,
  wins: () => 'Wins',
  team_name: () => 'Team name (A–Z)',
};

const Item = ({ code, children }) => (
  <span className="whitespace-nowrap"><strong className="text-slate-700">{code}</strong> = {children}</span>
);

// Public standings legend: column codes for the sport and the order ties are broken in.
export function StandingsLegend({ labels = {}, tieBreakers = [], showNrr }) {
  const l = {
    pf: labels.points_for || 'PF', pa: labels.points_against || 'PA', pd: labels.point_diff || 'Diff',
    pfFull: labels.points_for_full || 'Points For', paFull: labels.points_against_full || 'Points Against',
    pdFull: labels.point_diff_full || 'Point Differential',
  };
  const chain = ['Pts', ...tieBreakers.filter((f) => TB_LABEL[f]).map((f) => TB_LABEL[f](l))];
  if (!tieBreakers.includes('team_name')) chain.push(TB_LABEL.team_name());
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 text-xs text-slate-500 space-y-2" data-testid="public-standings-legend">
      <div className="flex flex-wrap gap-x-4 gap-y-1.5" data-testid="public-standings-legend-columns">
        <Item code="GP">Games Played</Item>
        <Item code="W">Wins</Item>
        <Item code="L">Losses</Item>
        <Item code="D">Draws</Item>
        <Item code={l.pf}>{l.pfFull}</Item>
        <Item code={l.pa}>{l.paFull}</Item>
        <Item code={l.pd}>{l.pdFull}</Item>
        {showNrr && <Item code="NRR">Net Run Rate (runs per over scored minus conceded)</Item>}
        <Item code="Pts">Standings Points</Item>
        <Item code="Win %">Win Percentage</Item>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
          <span className="w-3 h-3 rounded bg-amber-100 border border-amber-200" /> Top 3
        </span>
      </div>
      <p className="flex items-start gap-1.5 text-slate-600" data-testid="public-standings-legend-tiebreakers">
        <Info className="w-3.5 h-3.5 mt-px shrink-0 text-slate-400" />
        <span><strong className="text-slate-700">Ranking order:</strong> {chain.join(' → ')}</span>
      </p>
    </div>
  );
}
